import { ref, readonly } from 'vue'

const DEFAULT_INITIAL_CASH = 370000
const STORAGE_KEY = 'initial_cash'

// Load from localStorage on initialization
const loadInitialCash = (): number => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
        const value = parseFloat(stored)
        if (!isNaN(value) && value > 0) {
            return value
        }
    }
    return DEFAULT_INITIAL_CASH
}

// Use ref to make it reactive
const initialCash = ref(loadInitialCash())

export function useInitialCash() {
    return {
        initialCash: readonly(initialCash),
        setInitialCash: (value: number) => {
            if (value <= 0) {
                console.warn('Initial cash must be greater than 0')
                return
            }
            initialCash.value = value
            localStorage.setItem(STORAGE_KEY, value.toString())
        },
        resetInitialCash: () => {
            initialCash.value = DEFAULT_INITIAL_CASH
            localStorage.removeItem(STORAGE_KEY)
        }
    }
}

// Export the default value for use in other modules
export const DEFAULT_CASH = DEFAULT_INITIAL_CASH

